import React from "react";
import RuleChips from "./RuleChips";
import { formatComposition, moraleLabel, moraleClass, isAtMax, qtyRangeLabel } from "../lib/army";

export default function UnitCard({ unit, currentQty, onAdd, sectionFull }) {
  const atMax = isAtMax(unit, currentQty);
  const qtyLabel = qtyRangeLabel(unit, currentQty);
  const inactive = atMax || sectionFull;
  return (
    <div className={"unit-card" + (inactive ? " at-max" : "")} data-testid={`unit-card-${unit.id}`}>
      <div className="unit-card-header">
        <div className="unit-name">{unit.name}</div>
        {qtyLabel && <div className={"qty-range-badge" + (atMax ? " at-max" : "")}>{qtyLabel}</div>}
      </div>
      <div className="unit-tag">{unit.category}</div>
      <div className="unit-card-info">
        <div className="unit-stats">{formatComposition(unit.unitComposition)}</div>
        <RuleChips rules={unit.specialRules} />
        {unit.notes && <div className="unit-notes">{unit.notes}</div>}
      </div>
      <div className="unit-card-bottom">
        <div className="cost-group">
          <div className="morale-slot">
            {unit.morale && <div className={"morale-tag " + moraleClass(unit.morale)}>{moraleLabel(unit.morale)}</div>}
          </div>
          <div className="unit-cost">
            <span className="pts-val">{unit.points}</span> pts
            <span className="br-badge">BR: <span className="br-val">{unit.br || 0}</span></span>
          </div>
        </div>
        <button
          className="add-btn"
          type="button"
          disabled={inactive}
          onClick={() => onAdd(unit.id)}
          data-testid={`add-unit-${unit.id}`}
        >
          + Add
        </button>
      </div>
    </div>
  );
}
